// src/lib/redux/features/settingsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GeneralSettings {
  [key: string]: any;
}

interface BusinessSettings {
  [key: string]: any;
}

interface SettingsState {
  generalSettings: GeneralSettings | null;
  businessSettings: BusinessSettings | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  generalSettings: null,
  businessSettings: null,
  isLoading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setGeneralSettings: (state, action: PayloadAction<GeneralSettings>) => {
      state.generalSettings = action.payload;
    },
    setBusinessSettings: (state, action: PayloadAction<BusinessSettings>) => {
      state.businessSettings = action.payload;
    },
    setSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSettingsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearSettings: (state) => {
      state.generalSettings = null;
      state.businessSettings = null;
      state.error = null;
    },
  },
});

export const {
  setGeneralSettings,
  setBusinessSettings,
  setSettingsLoading,
  setSettingsError,
  clearSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;
